export class BaseService<T> {
    constructor(private repo: any) {}
    async getOne(id: string, params?: any) {
        return await this.repo.getOne(id, params)
    }

    async getAll(params?: { page?: number; from?: Date; to?: Date; query?: string } | any, useCacheIfNewerThanThisInSeconds: number = 0) {
        return await this.repo.getAll(params, useCacheIfNewerThanThisInSeconds)
    }

    async create(dto: Partial<T>, params?: any) {
        return await this.repo.create(dto, params)
    }

    async update(id: string, dto: Partial<T>, params?: any) {
        return await this.repo.update(id, dto, params)
    }

    async remove(id: string) {
        await this.repo.remove(id)
    }
}
